<template>
  <agent-detail :is-edit='false'>
  </agent-detail>
</template>

<script>
import AgentDetail from './components/AgentDetail'

export default {
  name: 'CreateAgent',
  components: {
    AgentDetail
  }
}
</script>

